import * as yup from "yup"
import type { NamedEntity } from "../../types"

export function initialValuesNamedEntity(namedEntity?: NamedEntity | undefined) {
  if (namedEntity) {
    return namedEntity
  }
  return {
    name: "",
    entity_type: "",
    description: "",
    link: "",
  }
}

export function validationSchemaNamedEntity() {
  return yup.object().shape({
    name: yup.string().required("Campo obbligatorio"),
    entity_type: yup.string().required("Campo obbligatorio"),
  })
}
